// Scroll positions per screen. Each top-level tab keeps its own while the user switches tabs, and
// coming back from a category screen, Settings or a filtered Activity returns to where the screen
// underneath was. A screen opened fresh (a category, Settings, a new Activity filter) starts at the top.

export interface ScrollView {
  tab: string;
  categoryId: string | null;
  settingsPage?: string | null;
  settle?: boolean;
}

/** The key a position is kept under: the screen showing (Splits over a screen, a category over a tab, a Settings page, the tab). */
export function viewKey(v: ScrollView): string {
  const base = v.categoryId ? `${v.tab}/category:${v.categoryId}` : v.tab === 'settings' && v.settingsPage ? `settings/${v.settingsPage}` : v.tab;
  return v.settle ? `${base}/splits` : base;
}

export class ScrollMemory {
  private positions = new Map<string, number>();

  /** Remember where the screen is before leaving it. */
  save(v: ScrollView, y: number) {
    this.positions.set(viewKey(v), Math.max(0, Math.round(y)));
  }

  /** Where to scroll on arriving: the remembered position, or the top when opened fresh. */
  restore(v: ScrollView, fresh = false): number {
    if (fresh) {
      this.positions.delete(viewKey(v));
      return 0;
    }
    return this.positions.get(viewKey(v)) ?? 0;
  }

  /** Drop a remembered position (Settings opened from a tab starts its menu at the top). */
  forget(v: ScrollView) {
    this.positions.delete(viewKey(v));
  }
}
